/* ============================================================
   Dathent — TASK-331 (D6) read-entitlement helper
   A lapsed org (accessState === 'lapsed') must still be able to READ
   everything it already created (brand kit, research report, strategy,
   autopilot config/history, connected accounts, ...) even though every
   PLAN_ENTITLEMENTS.lapsed feature flag is false — that pseudo-plan means
   "cannot create/run/regenerate", never "cannot see". The gateway's GET/HEAD
   read exemption already returns the full underlying data on any read call;
   this is the ONE place the SPA decides whether to render it or hide it
   behind a locked/upgrade wall (brief: "Derive a read-entitlement helper ...
   in ONE place").

   NEVER use this at a create/run/regenerate action gate — those must stay
   blocked. The backend is the source of truth there: it 402s with
   PLAN_LAPSED, and every such handler already checks `err.code ===
   'PLAN_LAPSED'` first (see UpgradeModal's 'renew' variant). This helper only
   re-derives whether to SHOW data the org is still entitled to read.
   ============================================================ */

// entitlements: the object returned by GET /api/billing/entitlements
// (dashboard.entitlements / api.billing.getEntitlements()).
// featureKey: the entitlements.features.* flag name that normally gates the
// feature (e.g. 'research', 'autopilot').
export function canReadEntitledFeature(entitlements, featureKey) {
  if (!entitlements) return false;
  if (entitlements.features?.[featureKey] === true) return true;
  return entitlements.accessState === 'lapsed' && entitlements.hasSubscriptionHistory === true;
}
